import { SetStateAction } from "react";

export const STATIC = {
  CDI: 14.65, // Current CDI rate (%)
  IPCA: 4.5, // Current IPCA rate (%)
  INVESTMENT_TYPES: [
    "CDB",
    "LCI",
    "LCA",
    "CRI",
    "CRA",
    "DEBÊNTURE",
    "DEBÊNTURE INCENTIVADA",
    "TESOURO DIRETO",
  ],
  YIELD_TYPES: ["pré-fixado", "% do cdi", "taxa fixada + ipca"],
};

export const calculateIRRate = (months: number): number => {
  if (months <= 6) return 0.225;
  if (months <= 12) return 0.2;
  if (months <= 24) return 0.175;
  return 0.15;
};

export const calculateYield = (
  type: string,
  yieldType: string,
  rate: string,
  months: number
): string => {
  let annualYield = parseFloat(rate);

  if (yieldType === "% do cdi") {
    annualYield = (annualYield / 100) * STATIC.CDI;
  } else if (yieldType === "taxa fixada + ipca") {
    annualYield += STATIC.IPCA;
  }

  const irRate = calculateIRRate(months);

  switch (type) {
    case "LCI":
    case "LCA":
    case "CRI":
    case "CRA":
    case "DEBÊNTURE INCENTIVADA":
      break;
    default:
      annualYield *= 1 - irRate;
  }

  return annualYield.toFixed(2);
};

export function calculate(
  investment1: {
    type: string;
    yieldType: string;
    rate: string;
    months: string;
  },
  investment2: {
    type: string;
    yieldType: string;
    rate: string;
    months: string;
  },
  setErrors: {
    (
      value: SetStateAction<{
        investment1: {
          type: boolean;
          yieldType: boolean;
          rate: boolean;
          months: boolean;
        };
        investment2: {
          type: boolean;
          yieldType: boolean;
          rate: boolean;
          months: boolean;
        };
      }>
    ): void;
    (arg0: {
      investment1: {
        type: boolean;
        yieldType: boolean;
        rate: boolean;
        months: boolean;
      };
      investment2: {
        type: boolean;
        yieldType: boolean;
        rate: boolean;
        months: boolean;
      };
    }): void;
  },
  setShowErrorMessage: {
    (value: SetStateAction<boolean>): void;
    (arg0: boolean): void;
  },
  setResult: { (value: SetStateAction<string>): void; (arg0: string): void }
) {
  return () => {
    const newErrors = {
      investment1: {
        type: !investment1.type,
        yieldType: !investment1.yieldType,
        rate: !investment1.rate,
        months: !investment1.months,
      },
      investment2: {
        type: !investment2.type,
        yieldType: !investment2.yieldType,
        rate: !investment2.rate,
        months: !investment2.months,
      },
    };

    setErrors(newErrors);

    if (
      Object.values(newErrors.investment1).some(Boolean) ||
      Object.values(newErrors.investment2).some(Boolean)
    ) {
      setShowErrorMessage(true);
      return;
    }

    setShowErrorMessage(false);

    const yield1 = calculateYield(
      investment1.type,
      investment1.yieldType,
      investment1.rate,
      parseInt(investment1.months)
    );
    const yield2 = calculateYield(
      investment2.type,
      investment2.yieldType,
      investment2.rate,
      parseInt(investment2.months)
    );

    const resultText = `O investimento **${
      investment1.type
    }** vai render **${yield1}% a.a** com as taxas atuais, considerando um período de **${
      investment1.months
    } meses**, enquanto o investimento **${
      investment2.type
    }** vai render **${yield2}% a.a** com as taxas atuais, considerando um período de **${
      investment2.months
    } meses**.
      Nessas condições, atualmente: o investimento **${
        parseFloat(yield1) > parseFloat(yield2)
          ? investment1.type
          : investment2.type
      }** é melhor que o investimento **${
      parseFloat(yield1) > parseFloat(yield2)
        ? investment2.type
        : investment1.type
    }**. Lembrando que essas condições são sazonais e podem mudar.`;

    setResult(resultText);
  };
}
